module.exports = __webpack_public_path__ + "img/classise.48b2013b.png";